export default __webpack_public_path__ + "8ec18d8f544dc48b3156e06db9d4f79d.svg";